import { render, staticRenderFns } from "./TodoYGCase.vue?vue&type=template&id=134a2aa9&"
import script from "./TodoYGCase.vue?vue&type=script&lang=js&"
export * from "./TodoYGCase.vue?vue&type=script&lang=js&"
import style0 from "./TodoYGCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports